import { Icon, Tooltip } from '@efast_public/fjd-component-library';
import {
  IconAppearance,
  IconGlyph
} from '@efast_public/fjd-component-library/build/src/components/Icon/Icon.types';
import {
  VersandChannel,
  VersandStatus
} from '../../../api/models/Nachrichten/NachrichtModel';

interface VersandStatusBadgeProps {
  readonly status: VersandStatus;
  readonly channel?: VersandChannel;
}

function versandStatusConfig(
  status: VersandStatus,
  channel?: VersandChannel
): {
  name: IconGlyph;
  label: string;
  variant?: IconAppearance;
} {
  if (
    status === VersandStatus.SUCCESSFUL &&
    channel === VersandChannel.POSTAL
  ) {
    return {
      name: 'email',
      label: 'Postalischer Versand wurde im System hinterlegt',
      variant: 'success'
    };
  }
  switch (status) {
    case VersandStatus.SCHEDULED:
      return { name: 'time', label: 'Wartet auf Versand' };
    case VersandStatus.DISPATCHING:
    case VersandStatus.DISPATCHED:
      return { name: 'time', label: 'Wartet auf Versandbestätigung...' };
    case VersandStatus.SUCCESSFUL:
      return {
        name: 'checkmark-outline',
        label: 'Erfolgreich versendet',
        variant: 'success'
      };
    case VersandStatus.FAILED:
      return {
        name: 'warning-outline',
        label: 'Versand fehlgeschlagen',
        variant: 'error'
      };
    case VersandStatus.CANCELED:
      return {
        name: 'close-outline',
        label: 'Versand abgebrochen',
        variant: 'warning'
      };
    case VersandStatus.OVERDUE:
      return {
        name: 'alarm',
        label: 'Versandbestätigung dauert unverhältnismäßig lange',
        variant: 'warning'
      };
  }
}

export default function VersandStatusBadge({
  status,
  channel
}: VersandStatusBadgeProps) {
  const { name, label, variant } = versandStatusConfig(status, channel);
  return (
    <Tooltip placement="auto" tooltip={label}>
      <span>
        <Icon name={name} title={label} variant={variant ?? undefined} />
      </span>
    </Tooltip>
  );
}
